export const HOME_PAGE = {
  banner: 'Найди свою любимую задачу',
  secondary:
    'Самые интересные задачи по физике для школьников с\u00A0ответами и\u00A0решениями'
};

export const SUBSCRIPTION_STEPS_HEADINGS = {
  stepTwo: 'Создание учётной записи на портале «Ньютоник»'
};

export const PAYMENT_DESCRIPTION = 'Годовая подписка на платформу «Ньютоник»';
export const REFUND_DESCRIPTION = 'Двойной платеж, возврат избыточной суммы';

export const NOT_FOUND = 'Запрошенная страница не найдена';
export const TRY_AGAIN = 'Запрошенная страница не найдена';
